import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHanger = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.0039 15.7261L12.625 10.5272V9.54939C13.8747 9.26359 14.8125 8.14787 14.8125 6.8125C14.8125 5.2616 13.5503 4 12 4C10.4491 4 9.1875 5.2616 9.1875 6.8125C9.1875 7.15796 9.46704 7.4375 9.8125 7.4375C10.158 7.4375 10.4375 7.15796 10.4375 6.8125C10.4375 5.95068 11.1382 5.25 12 5.25C12.8618 5.25 13.5625 5.95068 13.5625 6.8125C13.5625 7.67432 12.8618 8.375 12 8.375C11.6545 8.375 11.375 8.65454 11.375 9V10.5272L2.99548 15.7261C2.37232 16.1143 2 16.7832 2 17.5168C2 18.679 2.94543 19.625 4.10754 19.625H19.8918C21.054 19.625 22 18.679 22 17.5168C22 16.7832 21.6277 16.1143 21.0039 15.7261ZM19.8918 18.375H4.10754C3.63453 18.375 3.25 17.9905 3.25 17.5168C3.25 17.2178 3.40198 16.9455 3.65527 16.7881L12 11.6105L20.3447 16.7881C20.5986 16.9456 20.75 17.2178 20.75 17.5168C20.75 17.9905 20.3655 18.375 19.8918 18.375Z",
		fill: "currentColor"
	})
});
export default SvgHanger;
